module.exports = __webpack_public_path__ + "img/client-wl13bar.e0fbff63.png";